import React, { forwardRef } from 'react'
import { Button as CommonButton } from '@popmenu/common-ui'

import { ButtonProps } from './ButtonProps'
import { useButtonStyles } from './ButtonStyles'
import { deriveButtonProps } from './util/deriveButtonProps'

interface ButtonType {
  <C extends React.ElementType = 'a'>(props: ButtonProps<C> & { component?: C }): React.ReactElement
  displayName?: string
}

// eslint-disable-next-line react/display-name -- false positive
export const Button = forwardRef<HTMLButtonElement, ButtonProps>((allProps, ref) => {
  // The annotation is required because ButtonProps is polymorphic
  const props: ButtonProps = {
    ...allProps,
    textTransform: allProps.textTransform ?? 'uppercase',
    variant: allProps.variant ?? 'primary',
  }
  const { children, variant: remove, classes: classesOverride, ...commonProps } = props
  const classes = useButtonStyles(props)
  const derivedProps = deriveButtonProps(props)
  const mergedProps = {
    ...derivedProps,
    ...commonProps,
  }

  return (
    <CommonButton
      ref={ref}
      classes={{
        ...classes,
        ...classesOverride,
      }}
      disableElevation={true}
      {...mergedProps}
    >
      {children}
    </CommonButton>
  )
}) as ButtonType

Button.displayName = 'Button'
